/* global Plotly */
'use strict'

import CloudDataConnector from '../api.js'

export default class PlotController {
  /**
   * Represents a plot controller, querying API according to options and displaying plots
   */

  constructor (root, dataFunction) {
    this.uiElements = {}
    this.uiParams = {}
    this.internal = {
      root: $(root),
      dataFunction,
      drawNode: $(root).find('[data-id="plot-draw"]').get(0),
      plotParams: {}
    }
  }

  async init () {
    const that = this
    await that.wire()
    await that.loadOptions()
    await that.initialLoad()
  }

  async wire () {
    const that = this

    // Connect station options (if any)
    that.uiElements.station = that.internal.root.find('[data-id="plot-station"]')
    that.uiElements.station.on('change', function () {
      that.refresh()
    })

    // Connect season options (if any)
    that.uiElements.season = that.internal.root.find('[data-id="plot-season"]')
    that.uiElements.season.on('change', function () { that.refresh() })

    // Connect plot explicit params (if any)
    that.internal.plotParams.staticPlot = that.internal.root.find('[data-id="plot-param"][name="staticPlot"]').val()

    /// Plot layout params
    that.uiParams.height = that.internal.root.attr('data-plot-height')
  }

  async loadOptions () {
    // Inject station list and season list into UI (if any)
    const that = this

    if (that.uiElements.station.length && that.uiElements.station.prop('tagName') === 'SELECT') {
      const stationWhitelist = ['232', '256', '235', '234', '231', '229', '230', '205']
      const allStations = await new CloudDataConnector().getEquipments({
        type: 'temperature'
      })
      const filteredStations = allStations.filter(station => stationWhitelist.includes(station.id))
      for (const station of filteredStations) {
        $('<option/>', { value: station.id, selected: (station.id === '231' ? 'selected' : null) }).text(station.city + (station.altitude !== null ? ' - ' + station.altitude + 'm' : '')).appendTo(that.uiElements.station)
      }
    }

    if (that.uiElements.season.length && that.uiElements.station.prop('tagName') === 'SELECT') {
      const allSeasons = [{ name: 'Printemps', value: 'Spring' }, { name: 'Ete', value: 'Summer' }, { name: 'Automne', value: 'Fall' }, { name: 'Hiver', value: 'Winter' }]
      for (const season of allSeasons) {
        $('<option/>', { value: season.value }).text(season.name).appendTo(that.uiElements.season)
      }
    }
  }

  async refresh () {
    const that = this
    await that.animatedLoad()
  }

  async initialLoad () {
    const that = this
    const plotData = await this.internal.dataFunction(that)
    await that.initialDraw(plotData)
  }

  async animatedLoad () {
    const that = this
    const plotData = await this.internal.dataFunction(that)
    await that.animatedDraw(plotData)
  }

  async initialDraw (dataResponse) {
    // Run Plotly
    const data = dataResponse.data
    const layout = dataResponse.layout
    const staticPlot = this.internal.plotParams.staticPlot
    Plotly.newPlot(this.internal.drawNode,
      data, layout,
      { displayModeBar: false, staticPlot })
  }

  async animatedDraw (dataResponse) {
    // Run Plotly (animation deactivated du to side effects with layout)
    const data = dataResponse.data
    const layout = dataResponse.layout
    const staticPlot = this.internal.plotParams.staticPlot
    Plotly.newPlot(this.internal.drawNode,
      data, layout,
      { displayModeBar: false, staticPlot })
  }
}
